import React from 'react';
import ReactPlayer from 'react-player';

const Scenario5Video2 = () => {
    return (
        <div className='Scenario1VideoWrap Scenario1Video3'>
            <ReactPlayer url='https://youtu.be/j26YjLJhyEk' controls={true} />
        </div>
    );
}

export default Scenario5Video2;